import React from "react";
import Async from 'react-select/async';
import styles from "../styles.module.scss";
import { CustomStyleDynamicWidth } from "../helper";
import { useTranslation } from "react-i18next";

const SearchableSelect = ({
  title,
  onChange,
  loadOptions,
  queryName,
  defaultValue,
  placeholder,
  allQueryParams = null,
}) => {
  const { t } = useTranslation();

  const handleChange = (selection) => {
    onChange({
      [`${queryName}`]: selection?.value,
      [`${queryName}_name`]: selection?.label,
    });
  };

  return (
    <div className={styles.filter_container}>
      <div className={styles.title}>{title}</div>
      <Async
        key={allQueryParams.toString()}
        defaultValue={defaultValue?.value ? defaultValue : null}
        styles={CustomStyleDynamicWidth}
        maxMenuHeight={200}
        components={{
            IndicatorSeparator: () => null,
        }}
        placeholder={placeholder}
        menuPlacement="bottom"
        loadOptions={loadOptions}
        defaultOptions={true}
        isClearable
        onChange={handleChange}
        noOptionsMessage={() => t('No options')}
      />
    </div>
  );
};

export default SearchableSelect;
